import React from 'react';

const OrderInvoiceManagementPage = React.lazy(() => import('pages/OrderInvoiceManagement/OrderInvoiceManagementPage'));

const routes = [
  {
    path: '/order-invoice-management',
    exact: true,
    name: 'Quản lý hóa đơn bán hàng',
    function: 'SL_ORDER_INVOICE_MANAGEMENT_VIEW',
    component: OrderInvoiceManagementPage,
  },
];

export default routes;
